var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-blocks center-scroll-x",class:{'dark':_vm.dark},style:({
    'padding-top':_vm.paddingTop+'px',
    'padding-bottom':_vm.paddingBottom+'px',
  })},_vm._l((_vm.colors),function(color,i){return _c('color-block',{key:i,attrs:{"color":color,"selected":_vm.value==color},on:{"click":function () { return _vm.$emit('input', color); }}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }